export default {
  SUBURBS: `companies/:company_id/suburbs`
}